import { Routes, Route } from "react-router-dom";

import AdminLocks from "../Admin/AdminLocks";
import LockEvents from "../LockEvents";
import LockAutomation from "../LockAutomation";
import LockAutomationEdit from "../LockAutomationEdit";
import LockHolidayEdit from "../LockHolidayEdit";
import LockEdit from "./LockEdit";

export default function Locks() {
  return (
    <Routes>
      <Route path="/" element={<AdminLocks />} />
      <Route path="/:lockId/edit" element={<LockEdit />} />
      <Route path="/:lockId/events" element={<LockEvents />} />
      <Route path="/:lockId/automation" element={<LockAutomation />} />
      <Route path="/:lockId/automation/edit" element={<LockAutomationEdit />} />
      <Route path="/:lockId/holiday/edit" element={<LockHolidayEdit />} />
    </Routes>
  );
}
